import { useEffect, useState } from 'react';
import {
  Select, MenuItem, FormControl, InputLabel,
  FormHelperText, SelectChangeEvent, SelectProps, Box,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../reduxStore/Store';
import { WorkflowStatut } from '../../models/models';
import { fetchWorkflowStatuts } from '../../reduxStore/WorkflowStatutSlice';

interface SelectWorkflowStatutProps
  extends Omit<SelectProps<number | string>, 'value' | 'onChange'> {
  onStatutChange: (statut: WorkflowStatut | null) => void;
  selectedStatutId?: number | null;
  docTypeCode?: string | null;   // filtre optionnel par type de doc
  label?: string;
}

const SelectWorkflowStatut: React.FC<SelectWorkflowStatutProps> = ({
  onStatutChange,
  selectedStatutId,
  docTypeCode,
  label = 'Statut',
  ...selectProps
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { statutsData, loading, error } = useSelector((state: any) => state.WorkflowStatutSlice);
  const [selectedId, setSelectedId] = useState<number | string>(selectedStatutId ?? '');

  useEffect(() => {
    dispatch(fetchWorkflowStatuts({
      doc_type_code: docTypeCode ?? null,
      limit: 100,
      offset: 0,
    }));
  }, [dispatch, docTypeCode]);

  useEffect(() => {
    setSelectedId(selectedStatutId ?? '');
  }, [selectedStatutId]);

  const handleChange = (event: SelectChangeEvent<number | string>) => {
    const id = event.target.value;
    if (id === '') {
      setSelectedId('');
      onStatutChange(null);
      return;
    }
    const selected = (statutsData as WorkflowStatut[]).find(s => s.id === Number(id)) ?? null;
    setSelectedId(Number(id));
    onStatutChange(selected);
  };

  return (
    <FormControl fullWidth variant="outlined" error={!!error} size="small">
      <InputLabel>{label}</InputLabel>
      <Select
        value={selectedId}
        onChange={handleChange}
        label={label}
        disabled={loading}
        {...selectProps}
      >
        <MenuItem value="">— Tous —</MenuItem>
        {(statutsData as WorkflowStatut[]).map(s => (
          <MenuItem key={s.id} value={s.id!}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{
                width: 10, height: 10, borderRadius: '50%',
                bgcolor: s.couleur ?? '#9E9E9E', flexShrink: 0,
              }} />
              {s.libelle}
            </Box>
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default SelectWorkflowStatut;
